import React, { Component } from "react";
import config from "./../../common/config";
import core from "./../../common/core";
import Popup from "./../../componentsReusable/popup";
import Trans from "./../../componentsReusable/trans";
let setTimeoutObj = null;
class PopupAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  onClickDecline = () => {
    this.showHideAlert();
  };
  onClickAccept = () => {
    this.showHideAlert();
  };
  showHideAlert = () => {
    this.props.showHideAlert && this.props.showHideAlert(false, "", "", "");
  };
  render() {
    let self = this;
    const { onClickDecline, onClickAccept, props } = self;
    let { isShow, titleText, nodeButtons, sClass, headerText } = props;
    if (isShow) {
      return (
        <div className={"si-popup__container " + sClass}>
          <div className="si-popup__wrap zoom">
            <div className="si-popup__head">
              <div className="si-popup__heading">{headerText}</div>
            </div>
            <div className="si-popup__body">
              {titleText}
              <div className="si-btn-wrap">{nodeButtons}</div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}
export default PopupAlert;
